import React from 'react';
import PropTypes from 'prop-types';
import styled from 'styled-components';
import ProgramForm from '../ProgramForm';
import { RowSummary } from '../../../SharedSC/DashboardSC';
import {
  validateProgramCode,
  validateCodeDescription
} from '../../../../../helpers/validateCodes';
import { validateStringProperty } from '../../../../../helpers/validateGeneric';

const Layout = styled.div`
  display: flex;
  flex-wrap: wrap;
  width: 100%;
  height: auto;
  background: ${props => props.theme.colors.white};
`;

const NewProgram = ({
  cipcode,
  discipline,
  newProgram,
  allPrograms,
  showValidationErrors,
  handleChange,
  handleRelatedProgramFieldChange,
  handleRelatedProgramAdd,
  handleRelatedProgramRemove,
  onPostCreate,
  clearNew
}) => (
  <Layout>
    <RowSummary>
      <ProgramForm
        cipcode={cipcode}
        discipline={discipline}
        program={newProgram}
        buttonText="Create"
        showValidationErrors={showValidationErrors}
        validateCode={() =>
          validateProgramCode(newProgram.code, allPrograms, 2)
        }
        validateTitle={title =>
          validateStringProperty(title, allPrograms, 'title')
        }
        validateDescription={validateCodeDescription}
        handleChange={event => handleChange(event)}
        handleRelatedProgramFieldChange={handleRelatedProgramFieldChange}
        handleRelatedProgramAdd={handleRelatedProgramAdd}
        handleRelatedProgramRemove={handleRelatedProgramRemove}
        onSubmit={onPostCreate}
        closeForm={clearNew}
      />
    </RowSummary>
  </Layout>
);

NewProgram.propTypes = {
  cipcode: PropTypes.object.isRequired,
  discipline: PropTypes.object.isRequired,
  newProgram: PropTypes.object,
  allPrograms: PropTypes.arrayOf(PropTypes.object),
  showValidationErrors: PropTypes.bool,
  handleChange: PropTypes.func,
  handleRelatedProgramFieldChange: PropTypes.func,
  handleRelatedProgramAdd: PropTypes.func,
  handleRelatedProgramRemove: PropTypes.func,
  onPostCreate: PropTypes.func,
  clearNew: PropTypes.func
};
NewProgram.defaultProps = {
  newProgram: {},
  allPrograms: [],
  showValidationErrors: false,
  handleChange: undefined,
  handleRelatedProgramFieldChange: undefined,
  handleRelatedProgramAdd: undefined,
  handleRelatedProgramRemove: undefined,
  onPostCreate: undefined,
  clearNew: undefined
};

export default NewProgram;
